<sb-card [loading]="loading" [loadingDelay]="1" [halfHeight]="halfHeight" [classes]="classes">
  <div card-header>
    <h3>{{'lang.globals.visitor' | translate}}</h3>
    <small>{{ 'lang.globals.betweenCountDays' | translate: {count: timespan ? timespan?.days : ' - '} }}</small>
  </div>
  <div card-header-more>
    <sb-comp-chart-control *ngIf="showChartControl" [showPlayerCull]="false" (dateChange)="setTimeFrame($event)"
                           (intervalChange)="setInterval($event)" [from]="from" [till]="till" [hideInterval]="hideInterval"
                           [interval]="interval">
      <ng-content>

      </ng-content>
    </sb-comp-chart-control>
  </div>
  <div card-body>
    <sb-chart #chart chartType="lineChart"
              [chartData]="visitorTimeData"></sb-chart>
    <div class="font-weight-normal mt-5 text-end" style="font-size: 12px" #chartLegend></div>
  </div>
</sb-card>
